import React, { useEffect, useMemo, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { db } from '../../../../firebase';
import { addBidderService, editItemService, getCurrentItemService } from './bids-item-service';
import { showErrorSnackbar, showWarningSnackbar } from '../../../shared/snackbar/snackbar-slice';
import { getBidsService } from '../bids-home-service';
import { collection, onSnapshot } from '@firebase/firestore';
import { setCurrentItem } from './bids-item-slice';

const useStyles = makeStyles({
  card: {
    maxWidth: '80%',
    margin: 'auto',
    marginTop: 50,
    height: '80%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  media: {
    height: '100%',
    width:'100%',
  },
  bidButton: {
    marginTop: 20,
    background: "#111111",
        color: "#fbbbd3",
        '&:hover': {
            backgroundColor: '#fbbbd3',
            color: '#111111',
        },
  },
  content: {
    textAlign: 'left',
    padding: 50
  },
  text: {
    color: "#111111",
  },
  title: {
    background:"#111111",
  },
  buttonText: {
    color: "#111111",
    '&:hover': {
        backgroundColor: '#fbbbd3',
        color: '#111111',
    },
  },
});

const BidsItem = () => {
  const classes = useStyles();
  // const { bid_id } = useParams();
  const isLoading = useSelector((state) => state.bidItemSlice.isLoading);
  const currentItem = useSelector((state) => state.bidItemSlice.currentItem);
  const [remainingTime, setRemainingTime] = useState('');
  const [isBidDialogOpen, setBidDialogOpen] = useState(false);
  const [disadbleBid, setDisableBid] = useState(false);
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [isValidEmail, setIsValidEmail] = useState(true);
  const dispatch = useDispatch();

  // temp
  const bidsCollection = useSelector((state) => state.bidsHomeSlice.rows);
  const [bid_id, set_bid_id] = useState("");

  // temp
  useEffect(() => {
    const fetchData = async () => {
        try {
            await getBidsService(dispatch, db, "bids");
        } catch(e) {
            dispatch(showErrorSnackbar("Something went wrong while trying to fetch."));
            console.error("BidsHome fetchData error: ", e);
        }
    };
    fetchData();
  }, [dispatch]);
  // temp
  useEffect(() => {
    const fetchData = async () => {
        try {
            if (bidsCollection.length) {
                const onGoingBid = bidsCollection.filter((bid) => bid.status === "On Going");
                if (onGoingBid.length) {
                  set_bid_id(onGoingBid[0].id);
                }
            }
        } catch(e) {
            dispatch(showErrorSnackbar("Something went wrong while trying to fetch."));
            console.error("BidsHome fetchData error: ", e);
        }
    };
    fetchData();
  }, [dispatch, bidsCollection]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (bid_id) {
          // Replace the following fetch call with your actual API request to get the item by bid_id
          await getCurrentItemService(dispatch, db, "bids", bid_id);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [bid_id, dispatch]);

  useEffect(() => {
    if (currentItem) {
      calculateRemainingTime();

      const intervalId = setInterval(() => {
        calculateRemainingTime();
      }, 1000);

      return () => clearInterval(intervalId);
    }
  }, [currentItem])

  useEffect(() => {
    if (currentItem) {
      const endDate = new Date(currentItem.date_end);
      const now = new Date();

      if (now > endDate) {
        // Auction has ended, display a message or take appropriate action
        setDisableBid(true);
      } else {
        setDisableBid(false);
      }
    }
  }, [currentItem]);

  // Use a local variable to store the memoized result
  const memoizedData = useMemo(() => {
    const unsubscribe = onSnapshot(collection(db, "bids"), (snapshot) => {
      const mappedData = snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
      const specificItem = mappedData.find(item => item.id === bid_id) || null;

      if (specificItem !== null && specificItem.current_bid !== currentItem.current_bid) {
        dispatch(setCurrentItem(specificItem));
      }
    });

    // Cleanup the listener when the component unmounts
    return () => unsubscribe();
  }, [bid_id, currentItem.current_bid, dispatch]);

  console.log(memoizedData);

  const calculateRemainingTime = () => {
    const startDate = new Date(currentItem.date_start);
    const endDate = new Date(currentItem.date_end);
    const now = new Date();

    let timeDiff;

    if (now < startDate) {
      // Auction hasn't started yet
      timeDiff = startDate - now;
    } else if (now > endDate) {
      // Auction has ended
      timeDiff = 0;
    } else {
      // Auction is ongoing
      timeDiff = endDate - now;
    }

    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

    const remainingTimeString = `${days}d ${hours}h ${minutes}m`;
    // const remainingTimeString = `${days}d ${hours}h ${minutes}m ${seconds}s`;

    setRemainingTime(remainingTimeString);
  };

  const handleEmailChange = (event) => {
    const enteredEmail = event.target.value;
    setEmail(enteredEmail);

    // Validate the email using a regular expression
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = emailRegex.test(enteredEmail);
    setIsValidEmail(isValid);
  };

  const handleNameChange = (event) => {
    const enteredName = event.target.value;
    setName(enteredName);
  };

  const handleBidButtonClick = () => {
    const endDate = new Date(currentItem.date_end);
    const now = new Date();

    if (now > endDate) {
      // Auction has ended, display a message or take appropriate action
      dispatch(showWarningSnackbar("Bidding has already ended. Please refresh your browser."))
    }
    setBidDialogOpen(true);
  };

  const handleBidDialogClose = () => {
    setBidDialogOpen(false);
  };

  const handleBidOptionClick = async (bid) => {
    try {
      const newFormData = {
        ...currentItem,
        current_bid: currentItem.current_bid + bid,
        email_address: email
      };

      const dateNow = new Date();
      const bidderFormData = {
        date_time: dateNow,
        email_address: email,
        name: name,
        bid_amount: currentItem.current_bid + bid,
      };
      await editItemService(dispatch, db, "bids", bid_id, newFormData);
      await addBidderService(dispatch, db, "bidders", bidderFormData)
    } catch (e) {
      dispatch(showWarningSnackbar("There has been a change. Please reload the page"));
      console.error("BidsItem handleBidOptionClick error: ", e);
    }
    handleBidDialogClose();
  };

  return (
    <Card className={classes.card}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={6}>
          <Typography variant="h6" color="textSecondary" style={{ margin: '10px 0' }}>
            {
              disadbleBid === true ? (
                "Bidding has ended"
              ) : (
                `Remaining Time: ${remainingTime}`
              )
            }
          </Typography>
          <CardMedia
            className={classes.media}
            component="img"
            alt="Sample Image"
            image={currentItem.image_url}
            // image="https://mir-s3-cdn-cf.behance.net/projects/404/e642db177335193.Y3JvcCw5NTgsNzUwLDEyMSww.jpeg"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={6}>
          <CardContent className={classes.content}>
            <Typography variant="h4" component="div" className={classes.text}>
              {currentItem.name}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {currentItem.code}
            </Typography>
            <br/>
            <Typography variant="body1" color="textSecondary">
              {currentItem.description}
            </Typography>
            <br/>
            <Typography variant="h6" color="textSecondary">
              Current Bid:{currentItem.current_bid}
            </Typography>
            {/* <Typography variant="body1" color="textSecondary">
              Latest Bidder: {currentItem.latest_bidder}
            </Typography> */}

            <Button
              variant="contained"
              color="primary"
              className={classes.bidButton}
              fullWidth
              onClick={handleBidButtonClick}
              disabled={disadbleBid}
            >
              Bid
            </Button>

            <Dialog
              open={isBidDialogOpen}
              // onClose={handleBidDialogClose}
              aria-labelledby="bid-dialog"
              aria-describedby="select-bid-amount"
            >
              <DialogTitle id="bid-dialog-title" className={classes.title}>Select Bid Amount</DialogTitle>
              <DialogContent>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      label="Email Address"
                      fullWidth
                      value={email}
                      onChange={handleEmailChange}
                      error={!isValidEmail}
                      helperText={!isValidEmail ? 'Invalid email address' : ''}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      label="Name"
                      fullWidth
                      value={name}
                      onChange={handleNameChange}
                      // error={!isValidEmail}
                      // helperText={!isValidEmail ? 'Invalid email address' : ''}
                    />
                  </Grid>
                  {
                    currentItem.current_bid === 0 && (
                      <Grid item xs={12}>
                        <Typography variant="body1" color="textSecondary">
                          You are the first bidder!
                        </Typography>
                        <Button
                          variant="contained"
                          className={classes.bidButton}
                          fullWidth
                          onClick={() => handleBidOptionClick(230)}
                          // disabled={!name}
                          disabled={!email && isValidEmail && !name}
                        >
                          +230
                        </Button>
                      </Grid>
                    )
                  }
                  {
                    currentItem.current_bid > 0 && (
                      <>
                        <Grid item xs={6}>
                          <Button
                            variant="contained"
                            className={classes.bidButton}
                            fullWidth
                            onClick={() => handleBidOptionClick(50)}
                            disabled={!name}
                            // disabled={!(email && isValidEmail)}
                          >
                            +50
                          </Button>
                        </Grid>
                        <Grid item xs={6}>
                          <Button
                            variant="contained"
                            className={classes.bidButton}
                            fullWidth
                            onClick={() => handleBidOptionClick(100)}
                            disabled={!name}
                            // disabled={!(email && isValidEmail)}
                          >
                            +100
                          </Button>
                        </Grid>
                      </>
                    )
                  }
                  {
                    isLoading === true && (
                      <Typography className={classes.text}>Bidding...</Typography>
                    )
                  }
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="text"
                  onClick={handleBidDialogClose}
                  color="primary"
                  className={classes.buttonText}
                  disabled={isLoading}
                >
                  Cancel
                </Button>
              </DialogActions>
            </Dialog>
          </CardContent>
        </Grid>
      </Grid>
    </Card>
  );
};

export default BidsItem;
